import { GET_PUBLICATIONS } from '../actions/types';
import { PostDispatch } from '../types';

const PublicationReducer = (state = null, action: PostDispatch) => {
    switch (action.type) {
        case GET_PUBLICATIONS:
            return action.payload;
        default:
            return state;
    }
};

export default PublicationReducer;
